import store from "../../../store";
import report_doc from "./report_doc.vue";

window.REPORT_DOC =  new Vue({
    store,

    name : "REPORT_DOC",

    el: '#report_doc',

    data () {
        return {
            showModal: false,
        }
    },
    created () {

    },

    components : {
        report_doc
    }
});
